import { render, staticRenderFns } from "./TaskDely.vue?vue&type=template&id=71e885c0&scoped=true"
import script from "./TaskDely.vue?vue&type=script&lang=js"
export * from "./TaskDely.vue?vue&type=script&lang=js"
import style0 from "./TaskDely.vue?vue&type=style&index=0&id=71e885c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e885c0",
  null
  
)

export default component.exports